<template>
    <div class="nav align-items-center ml-auto">
        <b-button
            id="tour-edit-dashboard-step-2"
            v-if="viewTypeIsWeb"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="flat-secondary"
            @click="resetCustomDashboard"
            class="btn-with-border"
            :disabled="isResetMode && !isTourActive ? 'disabled' : null"
        >
            <SVGResetDisabledIcon v-if="(isResetMode && (theme === 'light') || !isResetMode && (theme === 'dark')) && !isTourActive"/>
            <SVGResetIcon v-else/>
            <span class="ml-25">
                {{ $t('org.dashboard.Reset') }}
            </span>
        </b-button>
        <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="flat-secondary"
            @click="cancelCustomDashboard"
            class="btn-with-border btn-cancel-focus"
        >
            <SVGCancelLightIcon v-if="theme === 'light'"/>
            <SVGCancelDarkIcon v-else/>
            <span class="ml-25">
                {{ $t('org.dashboard.Cancel') }}
            </span>
        </b-button>
        <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="px-75 py-25 d-flex align-items-center"
            @click="saveCustomDashboard"
            :disabled="!checkIfEdited || (saveCustomDashboardStatus === 'loading') || (getCustomDashboardStatus === 'loading') ? 'disabled' : null"
        >
            <SVGSaveIcon/>
            <span class="ml-25">
                {{ $t('org.dashboard.Save Dashboard') }}
            </span>
        </b-button>
    </div>
</template>

<script>
import { defaultLayout } from '@/modules/Dashboard/_store/dummy-data'
import Ripple from 'vue-ripple-directive'
import SVGResetIcon from '@/assets/images/icons/header/icon_rotate-clockwise.svg'
import SVGResetDisabledIcon from '@/assets/images/icons/header/icon_rotate-clockwise-disabled.svg'
import SVGCancelLightIcon from '@/assets/images/icons/header/icon_x_light.svg'
import SVGCancelDarkIcon from '@/assets/images/icons/header/icon_x_dark.svg'
import SVGSaveIcon from '@/assets/images/icons/header/icon_dashboard-save.svg'
import useDashboardHeader from '@/composables/useDashboardHeader'
import useDashboardRender from '@/composables/useDashboardRender'
import { computed, inject } from '@vue/composition-api'
import useTour from '@/composables/useTour'

export default {
    components: {
        SVGResetIcon,
        SVGResetDisabledIcon,
        SVGCancelLightIcon,
        SVGCancelDarkIcon,
        SVGSaveIcon
    },
    directives: {
        Ripple
    },
    setup (props, context) {
        const { isTourActive } = useTour()
        const {
            isResetMode,
            updateResetMode,
            getCustomDashboardStatus,
            saveCustomDashboardStatus,
            checkIfEdited
        } = useDashboardHeader()
        const { layout, viewType } = useDashboardRender()
        const theme = inject('theme')
        updateResetMode(defaultLayout === layout.value)

        const cancelCustomDashboard = () => context.emit('setCustomDashboard', false)
        const saveCustomDashboard = () => context.emit('saveCustomDashboard')
        const resetCustomDashboard = () => context.emit('resetCustomDashboard')
        const viewTypeIsWeb = computed(() => viewType.value === 'web')

        return {
            isResetMode,
            isTourActive,
            cancelCustomDashboard,
            saveCustomDashboard,
            resetCustomDashboard,
            getCustomDashboardStatus,
            saveCustomDashboardStatus,
            viewTypeIsWeb,
            checkIfEdited,
            theme
        }
    }
}
</script>
<style>
/*   */
.btn-cancel-focus.btn-flat-secondary:focus {
    background-color: transparent !important;
}
.btn-with-border {
    margin-right: 0.5rem !important;
    padding: 0.25rem 0.75rem !important;
    display: flex;
    align-items: center;
    color: #535353 !important;
    border: 1px solid #B4B4B4 !important
}
.btn-with-border.disabled {
    color: #CECECE !important;
    border: 1px solid #DBDBDB !important;
}
.dark-layout .btn-with-border {
    color: #CECECE !important;
}
.dark-layout .btn-with-border.disabled {
    color: #82868b !important;
    border: 1px solid #535353 !important;
}
</style>
